import React, {useEffect} from 'react';

import {useHistory} from 'react-router-dom';

import Router from 'router/router';
import * as css from './css/cart';
import {observer} from 'mobx-react';
import useMyStores from "hooks/useMyStores";


function Cart(props) {

    const {className} = props;
    const history = useHistory()
    const {user, login, cart} = useMyStores()

    useEffect(() => {
        if (user.token) {
            cart.fetchGoodsCount().then();
        }
    }, [user.token]);

    return (
        <css.Cart
            className={className}
            onClick={() => {
                if (user.token) {
                    history.push({
                        pathname: Router.Cart.path
                    });
                } else {
                    login.show = true;
                }
            }}
        >
            <css.CartContainer>
                <div className='bg-img-wrapper'>
                    <img src={require('./img/bg.png')} alt='' className='bg-img'/>
                </div>
                {cart.goodsCount > 0 && (
                    <css.MessageBlock>{cart.goodsCount}</css.MessageBlock>
                )}
            </css.CartContainer>
            <css.Title>我的购物车</css.Title>
        </css.Cart>
    );
}

export default observer(Cart);
